import React, { useContext, useEffect, useRef, useState } from "react";
import { GoDotFill } from "react-icons/go";
import { IoIosArrowDown } from "react-icons/io";
import { IoInformationCircleOutline } from "react-icons/io5";
import { RiArrowRightSLine } from "react-icons/ri";
import PaymentPlan from "../images/payment-plan.svg";
import UnitTypefrom from "../images/unit-type.svg";
import { MdLocationOn } from "react-icons/md";
import { RiFileTextFill } from "react-icons/ri";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import { Swiper, SwiperSlide } from "swiper/react";
import developerLogo from "../images/developer.svg";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Pagination } from "swiper/modules";
import { Link, useNavigate } from "react-router-dom";
import { StoreContext } from "../context/StoreContext";
import { fatchAreaFind, formatShortNumber, getLastPathParam, getQuarter, sendWhatsAppMessage } from "../components/CommonFun";
import { API_Path, imgBaseUrl, wpNumber } from "../Const";
import EmailAgentModal from "../components/modal/EmailAgentModal";
import ContectModal from "../components/modal/ContectModal";
import CommonPagination from "../components/CommonPagination";
import { GetApi } from "../api/api-service";
import { AuthContext } from "../context/AuthContext";
import ImagesModal from "../components/modal/ImagesModal";
import dummyImg from "../images/dummy_person.png";
import VideoModal from "../components/modal/VideoModal";
import NoPropertyImg from "../images/no_property.png";
import { fatchcompletionTypeFind } from "../components/CommonApi";
import mapIcon from "../images/location.svg";
import noProperty from "../images/no-property-found.png";
import PropertySection from "../components/property/PropertySection";
import SpinnerLoader from "../components/loader/SpinnerLoader";
import { IoImageOutline } from "react-icons/io5";
import { IoPlayCircleOutline } from "react-icons/io5";
import { AiOutlineTable } from "react-icons/ai";
import { AiOutlineFilePdf } from "react-icons/ai";
import { GoArrowRight } from "react-icons/go";
import useTooltipPosition from "../components/CustomizedHook/updatePosition";
import { RELocation, REWhatsapp } from "../components/icons/IconSvg";
import PageTitle from "../components/PageTitle";

function ProjectDetails() {
    const descriptionRef = useRef();
    const UnitSectionRef = useRef(null);
    const PlanSectionRef = useRef(null);
    const AboutSectionRef = useRef(null);
    const navigate = useNavigate();
    // const location = useLocation();
    const { areaUnits, fetchAreaUnits, completionType, fetchCompletionType, categoriesType, fetchCategoriesType } = useContext(AuthContext);
    const { mediaProject, fetchMediaProject, DeveloperData, fetchDeveloper } = useContext(StoreContext);
    const { wrapperRef, tooltipRef, position, updatePosition } = useTooltipPosition();
    const [propertyTab, setPropertyTab] = useState("All");
    const [emailModalShow, setEmailModalShow] = useState(false);
    const [phoneModalShow, setPhoneModalShow] = useState({ show: false, data: "" });
    const [flooreModalShow, setFlooreModalShow] = useState({ show: false, data: [] });
    const [flooreVideoShow, setFlooreVideoShow] = useState({ show: false, data: [] });
    const [propertybyProject, setPropertybyProject] = useState([]);
    const [projectUnits, setProjectUnits] = useState([]);
    const [allProjectUnits, setAllProjectUnits] = useState([]);
    const [allProjectPayment, setAllProjectPayment] = useState([]);
    const [propertyFilter, setPropertyFilter] = useState([]);
    const [agentData, setAgentData] = useState([]);
    const [planTab, setPlanTab] = useState("");
    const [planData, setPlanData] = useState({});
    const [similarProjectData, setSimilarProjectData] = useState([]);
    const [recommendedSearch, setRecommendedSearch] = useState([]);
    const [projectData, setProjectData] = useState({});
    const [paginations, setPaginations] = useState({ currentPage: 1, pageSize: 10, totalPages: 1, showData: 1 });
    const [isExpanded, setIsExpanded] = useState({ description: false });
    const [maxHeight, setMaxHeight] = useState({ description: "76px" });
    const [shouldShowButton, setShouldShowButton] = useState({ description: false });
    const [loaders, setLoaders] = useState({ property: false, project: false, agent: false, pUnit: false, pPlan: false, pSimilar: false });
    const [propertySliug, setPropertySlug] = useState();
    const handleTab = (name) => setPropertyTab(name);
    useEffect(() => {
        fetchAgentData();
        fetchCategoriesType();
        fetchAreaUnits();
        fetchCompletionType();
    }, []);
    useEffect(() => {
        var urlValue = getLastPathParam();
        if (urlValue !== null && urlValue !== undefined && urlValue !== "") {
            let data = urlValue.split("_", 2)[1];
            fetchProject(data);
            fetchMediaProject(data);
            fetchProjectUnit(data);
            fetchProjectPayment(data);
            fetchSimilarPjtsDetails(data);
            fetchRecommendedSearches(data);
        } else navigate("/");
    }, []);
    useEffect(() => {
        if (propertybyProject.length > 0) {
            let data = fatchcompletionTypeFind(completionType, propertybyProject);
            if (propertyTab === "All") setPropertyFilter(data);
            else {
                const filteredProperties = data.filter((property) => property.completionType === propertyTab);
                setPropertyFilter(filteredProperties);
            }
        }
    }, [propertybyProject, propertyTab]);
    useEffect(() => {
        if (projectData?.developerId) fetchDeveloper(projectData?.developerId);
        if (projectData?.projectId) fetchPropertybyProject(paginations.currentPage, projectData?.projectId);
    }, [projectData]);
    const toggleExpanded = (key) => {
        const ref = descriptionRef;
        setIsExpanded((prev) => {
            const newState = !prev[key];
            setMaxHeight((prevMax) => ({
                ...prevMax,
                [key]: newState ? `${ref.current.scrollHeight}px` : "76px",
            }));
            return { ...prev, [key]: newState };
        });
    };
    useEffect(() => {
        const checkOverflow = () => {
            if (projectData?.projects?.description && descriptionRef.current) {
                setShouldShowButton((prev) => ({
                    ...prev,
                    description: descriptionRef.current.scrollHeight > 76,
                }));
            }
        };
        checkOverflow();
    }, [projectData?.projects?.description]);
    const handleModalHide = () => setEmailModalShow(false);
    const handlePhoneModalHide = () => setPhoneModalShow({ ...phoneModalShow, show: false });
    const tableCallBack = (page) => {
        fetchPropertybyProject(page, projectData?.projectId);
    };
    const fetchProject = async (id) => {
        try {
            setLoaders({ ...loaders, project: true });
            let res = await GetApi(API_Path.ProjectsDetails + `/details/${id}`);
            if (res && res.data.success) setProjectData(res.data.data);
            setLoaders({ ...loaders, project: false });
        } catch (error) {
            setLoaders({ ...loaders, project: false });
        }
    };
    const fetchPropertybyProject = async (page, id) => {
        try {
            setLoaders({ ...loaders, property: true });
            let res = await GetApi(API_Path.propertiesDetails + `/${id}?pageNumber=${page}&pageSize=10`);
            if (res && res.data.success) {
                setPropertybyProject(res.data.data);
                let page = res.data;
                setPaginations({ currentPage: page?.currentPage, pageSize: page?.pageSize, totalPages: page?.totalPages, showData: page?.totalRecords });
            }
            setLoaders({ ...loaders, property: false });
        } catch (error) {
            setLoaders({ ...loaders, property: false });
        }
    };
    const fetchProjectUnit = async (id) => {
        try {
            setLoaders({ ...loaders, pUnit: true });
            let res = await GetApi(API_Path.ProjectsDetails + `/units/${id}`);
            if (res && res.data.success) {
                let data = res.data.data;
                setAllProjectUnits(data);
            }
            setLoaders({ ...loaders, pUnit: false });
        } catch (error) {
            setLoaders({ ...loaders, pUnit: false });
        }
    };
    const fetchRecommendedSearches = async (id) => {
        try {
            let res = await GetApi(API_Path.recommendedProject + id);
            if (res && res.data.success) {
                let data = res.data.data;
                setRecommendedSearch(data);
            }
        } catch (error) {
            console.error("Error fetching area units:", error);
        }
    };
    const fetchProjectPayment = async (id) => {
        try {
            setLoaders({ ...loaders, pPlan: true });
            let res = await GetApi(API_Path.ProjectsDetails + `/payment-plans/${id}`);
            if (res && res.data.success) {
                let data = res.data.data;
                setPlanTab(data[0]?.uId);
                setPlanData(data[0]);
                setAllProjectPayment(data);
            }
            setLoaders({ ...loaders, pPlan: false });
        } catch (error) {
            setLoaders({ ...loaders, pPlan: false });
        }
    };
    const formatCategoryNames = (categories) => {
        const names = categories.map((cat) => cat.name);
        if (names.length === 1) return names[0];
        if (names.length === 2) return `${names[0]} & ${names[1]}`;
        return `${names.slice(0, -1).join(", ")} & ${names[names.length - 1]}`;
    };
    useEffect(() => {
        if (areaUnits && areaUnits?.length > 0) {
            fatchAreaFind(areaUnits, allProjectUnits);
            const unitsWithNames = fatchAreaFind(allProjectUnits, areaUnits);
            const categoryMap = new Map();
            unitsWithNames.forEach((item) => {
                if (!categoryMap.has(item.categoryId)) {
                    categoryMap.set(item.categoryId, {
                        categoryId: item.categoryId,
                        data: [],
                    });
                }
                const categoryGroup = categoryMap.get(item.categoryId);
                let unitGroup = categoryGroup.data.find((u) => u.unitName === item.unitName);
                if (!unitGroup) {
                    unitGroup = {
                        unitName: item.unitName,
                        subdata: [],
                    };
                    categoryGroup.data.push(unitGroup);
                }
                unitGroup.subdata.push(item);
            });
            const result = Array.from(categoryMap.values());
            const updatedProjectUnits = result.map((unit) => {
                const matchedCategory = categoriesType.find((cat) => cat.uId === unit.categoryId);
                return {
                    ...unit,
                    categoryName: matchedCategory ? matchedCategory.name : null,
                };
            });
            setProjectUnits(updatedProjectUnits);
        }
    }, [areaUnits, allProjectUnits, categoriesType]);
    const fetchAgentData = async () => {
        try {
            setLoaders({ ...loaders, agent: true });
            let res = await GetApi(API_Path.agentDetails + `?pageNumber=${1}&pageSize=${5}`);
            if (res && res.data.success) setAgentData(res.data.data);
            setLoaders({ ...loaders, agent: false });
        } catch (error) {
            setLoaders({ ...loaders, agent: false });
        }
    };
    const handleClose = () => setFlooreModalShow({ show: false, data: [] });
    const handleVideoClose = () => setFlooreVideoShow({ show: false, data: [] });
    const scrollToUnitSection = () => {
        UnitSectionRef.current?.scrollIntoView({ behavior: "smooth" });
    };
    const scrollToPlanSection = () => {
        PlanSectionRef.current?.scrollIntoView({ behavior: "smooth" });
    };
    const scrollToAboutSection = () => {
        AboutSectionRef.current?.scrollIntoView({ behavior: "smooth" });
    };
    const formatNames = (data) => {
        const names = data.map((cat) => cat.name);
        if (names.length === 1) return names[0];
        if (names.length === 2) return `${names[0]} & ${names[1]}`;
        return `${names.slice(0, -1).join(", ")} & ${names[names.length - 1]}`;
    };
    const fetchSimilarPjtsDetails = async (id) => {
        try {
            setLoaders({ ...loaders, pSimilar: true });
            let res = await GetApi(API_Path.similarPjtsDetails + id);
            if (res && res.data.success) setSimilarProjectData(res.data.data);
            setLoaders({ ...loaders, pSimilar: false });
        } catch (error) {
            setLoaders({ ...loaders, pSimilar: false });
        }
    };
    const handleSearchChange = (item) => {
        let splitData = item?.type?.split("+");
        let localitySlug;
        let categorySlug;
        let BHKSlug;
        if (splitData.length === 1) {
            localitySlug = splitData[0];
        } else if (splitData.length === 2) {
            localitySlug = splitData[0];
            BHKSlug = splitData[1];
        } else if (splitData.length === 3) {
            localitySlug = splitData[0];
            categorySlug = splitData[1];
            BHKSlug = splitData[2];
        }
        if (categorySlug) {
            const category = categoriesType.find((cat) => cat.name.toLowerCase() === categorySlug.toLowerCase());
            if (category) {
                categorySlug = category.slug;
            } else categorySlug = "";
        }
        if (splitData) {
            let findPRtdata = `/property/for-sale`;
            let firstParamAdded = false;
            const addParam = (param, value) => {
                if (value) {
                    findPRtdata += (firstParamAdded ? "&" : "/") + param + "=" + value;
                    firstParamAdded = true;
                }
            };
            addParam("categories", categorySlug || "");
            addParam("city", localitySlug || "");
            addParam("bed", BHKSlug || "");
            setPropertySlug(findPRtdata);
        }
    };
    return (
        <>
            <PageTitle title={projectData?.projects?.title} />
            <div className="project-details-sec">
                <div className="max-container">
                    <div className="project-info">
                        <div className="project-details-left">
                            {projectData?.projects?.title && (
                                <div className="project-name property_tle">
                                    <h1>{projectData?.projects?.title}</h1>
                                    {projectData?.projects?.notes && (
                                        <div className="wrapper" ref={wrapperRef} onMouseEnter={updatePosition}>
                                            <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    fill="none"
                                                    strokeMiterlimit="10"
                                                    strokeWidth="32"
                                                    d="M248 64C146.39 64 64 146.39 64 248s82.39 184 184 184 184-82.39 184-184S349.61 64 248 64z"
                                                ></path>
                                                <path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M220 220h32v116"></path>
                                                <path fill="none" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="32" d="M208 340h88"></path>
                                                <path d="M248 130a26 26 0 1 0 26 26 26 26 0 0 0-26-26z"></path>
                                            </svg>
                                            <div ref={tooltipRef} className={`tooltip ${position}`}>
                                                {projectData?.projects?.notes}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                            <div className="project-type">
                                <p>{projectData?.category && formatCategoryNames(projectData.category)}</p>
                            </div>
                            <div className="project-status">
                                {projectData?.projects?.completionType === "offplan" && (
                                    <div className="under-construction">
                                        <p>Under Construction</p>
                                    </div>
                                )}
                                {projectData?.completion?.completionPercentage > 0 && (
                                    <div className="project-completed">
                                        <p>{projectData?.completion?.completionPercentage}% Completed</p>
                                    </div>
                                )}
                                {projectData?.developer && projectData?.developer.length > 0 && (
                                    <div className="by-property">
                                        <a href={DeveloperData?.websiteUrl} title={projectData?.developer[0]} target="_blank" rel="noreferrer">
                                            <p>
                                                <GoDotFill />
                                                By <span>{projectData?.developer[0]}</span>
                                            </p>
                                        </a>
                                    </div>
                                )}
                            </div>

                            <div className="launch-info-wrapper">
                                {projectUnits.length > 0 && projectData?.monetaries?.currency && (projectData?.monetaries?.minimumPrice || projectData?.monetaries?.maximumPrice) && (
                                    <div className="launch-info">
                                        <div className="launch-price">
                                            <p>Launch Price</p>
                                            <h2 className="text-uppercase">
                                                {projectData?.monetaries?.currency}
                                                <span>{`${
                                                    projectData?.monetaries?.minimumPrice
                                                        ? formatShortNumber(projectData?.monetaries?.minimumPrice)
                                                        : formatShortNumber(projectData?.monetaries?.maximumPrice)
                                                }`}</span>
                                            </h2>
                                        </div>
                                        <div className="unit-link">
                                            <button onClick={scrollToUnitSection}>View unit types</button>
                                        </div>
                                    </div>
                                )}
                                {(allProjectPayment[0]?.postHandoverPercentageSum || allProjectPayment[0]?.preHandoverPercentageSum) && (
                                    <div className="launch-info">
                                        <div className="launch-price payment-price">
                                            <p>Payment Plan</p>
                                            <h2>
                                                <span>
                                                    {allProjectPayment[0]?.preHandoverPercentageSum} / {allProjectPayment[0]?.postHandoverPercentageSum}
                                                </span>
                                                <div className="wrapper" ref={wrapperRef} onMouseEnter={updatePosition}>
                                                    <IoInformationCircleOutline />
                                                    <div ref={tooltipRef} className={`tooltip ${position}`}>
                                                        <div className="payment-plan-head">
                                                            <h3>% OF PROPERTY VALUE TO BE PAID</h3>
                                                            <div className="payment-plan-show">
                                                                <span>Pre Handover</span>
                                                                <strong>
                                                                    {(allProjectPayment[0]?.downPaymentPercentage ? allProjectPayment[0]?.downPaymentPercentage : 0) +
                                                                        (allProjectPayment[0]?.preHandoverPercentage ? allProjectPayment[0]?.preHandoverPercentage : 0)}
                                                                    %
                                                                </strong>
                                                            </div>
                                                            <div className="payment-plan-show">
                                                                <span>Post Handover</span>
                                                                <strong>
                                                                    {(allProjectPayment[0]?.handoverPercentage ? allProjectPayment[0]?.handoverPercentage : 0) +
                                                                        (allProjectPayment[0]?.postHandoverPercentage ? allProjectPayment[0]?.postHandoverPercentage : 0)}
                                                                    %
                                                                </strong>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </h2>
                                        </div>
                                        <div className="unit-link">
                                            <button onClick={scrollToPlanSection}>View Payment Plan</button>
                                        </div>
                                    </div>
                                )}
                                {projectData?.completion?.completionDate && (
                                    <div className="launch-info">
                                        <div className="launch-price">
                                            <p>Handover</p>
                                            <h2>
                                                <span>{getQuarter(projectData?.completion?.completionDate)}</span>
                                            </h2>
                                        </div>
                                    </div>
                                )}
                            </div>
                            {projectData?.projects?.description && (
                                <div className="property-desc">
                                    <h2 className="project-title"> About {projectData?.projects?.title}</h2>
                                    <div
                                        ref={descriptionRef}
                                        className={`list_label_text w-100${shouldShowButton.description ? " desktop_description" : ""}${!isExpanded?.description ? " desktop_description_trim" : ""}`}
                                        style={{ maxHeight: maxHeight.description }}
                                    >
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: projectData?.projects?.description,
                                            }}
                                        ></div>
                                    </div>
                                    {shouldShowButton.description && (
                                        <button onClick={() => toggleExpanded("description")} className="readmore-btn">
                                            {isExpanded?.description ? "Read less" : "Read more"}
                                        </button>
                                    )}
                                </div>
                            )}
                            <div className="property-card-info">
                                {allProjectPayment.length > 0 && (
                                    <div className="info-card" onClick={scrollToPlanSection}>
                                        <div className="info-card-inner">
                                            <div className="info-card-text">
                                                <img src={PaymentPlan} alt="Payment Plan" />
                                                <h2>Payment Plan</h2>
                                            </div>
                                            <RiArrowRightSLine />
                                        </div>
                                    </div>
                                )}
                                {projectUnits.length > 0 && (
                                    <div className="info-card" onClick={scrollToUnitSection}>
                                        <div className="info-card-inner">
                                            <div className="info-card-text">
                                                <img src={UnitTypefrom} alt="Unit Types" />
                                                <h2>Unit Types</h2>
                                            </div>
                                            <RiArrowRightSLine />
                                        </div>
                                    </div>
                                )}
                                {projectData?.projects?.faqDescription && (
                                    <div className="info-card" onClick={scrollToAboutSection}>
                                        <div className="info-card-inner">
                                            <div className="info-card-text">
                                                <RiFileTextFill />
                                                <h2>About Project</h2>
                                            </div>
                                            <RiArrowRightSLine />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        {loaders.project ? (
                            <div className="project-details-right">
                                <SpinnerLoader />
                            </div>
                        ) : mediaProject?.images?.length > 0 ? (
                            <div className={mediaProject?.images?.length === 3 ? "project-details-right" : "project-img-wrapper"}>
                                {mediaProject?.images?.slice(0, 4).map((img, i) => (
                                    <img
                                        src={imgBaseUrl + img?.path}
                                        alt={img?.title}
                                        key={i}
                                        title={img?.title}
                                        onError={({ currentTarget }) => {
                                            currentTarget.onerror = null;
                                            currentTarget.src = `${NoPropertyImg}`;
                                        }}
                                        loading="lazy"
                                    />
                                ))}
                            </div>
                        ) : (
                            <img src={NoPropertyImg} className="img-fluid w-50" alt="No results matching your search" />
                        )}
                    </div>

                    <div className="off-plan-project">
                        <div className="project-plan-main">
                            <div className="off-plan-left">
                                {loaders.property ? (
                                    <SpinnerLoader padding={true} />
                                ) : (
                                    <>
                                        {propertybyProject?.length > 0 ? (
                                            <>
                                                <h2 className="project-plan-title">Properties in {projectData?.projects?.title}</h2>
                                                <div className="tab-panel">
                                                    <div className="tab-container">
                                                        <div className="profile-tab-btn">
                                                            <div className="tab-buttons">
                                                                <button className={`tab-btn${propertyTab === "All" ? " active" : ""}`} onClick={() => handleTab("All")}>
                                                                    All
                                                                </button>
                                                                {completionType.length > 0 &&
                                                                    completionType?.map((item, i) => (
                                                                        <button
                                                                            key={i}
                                                                            className={`tab-btn${propertyTab.toLowerCase() === item.type.toLowerCase() ? " active" : ""}`}
                                                                            onClick={() => handleTab(item.type)}
                                                                        >
                                                                            {item.name}
                                                                        </button>
                                                                    ))}
                                                            </div>
                                                        </div>
                                                        {propertyFilter && propertyFilter.length > 0 ? (
                                                            <div className="tab-content">
                                                                <PropertySection ltsProperties={propertyFilter} name="agent" agentData={agentData} />
                                                                {paginations.totalPages > 1 && (
                                                                    <>
                                                                        <CommonPagination
                                                                            currentPage={paginations.currentPage}
                                                                            pageSize={paginations.pageSize}
                                                                            totalPages={paginations.totalPages}
                                                                            tableCallBack={tableCallBack}
                                                                        />
                                                                        <div className="project-pagination">
                                                                            <p>
                                                                                {paginations.currentPage} to {propertyFilter.length} of {propertyFilter.length} Properties
                                                                                {/* {paginations.currentPage} to {paginations.showData} of {paginations.showData} Properties */}
                                                                            </p>
                                                                        </div>
                                                                    </>
                                                                )}
                                                            </div>
                                                        ) : (
                                                            <div className="project-notfound-img agent-property-left text-center">
                                                                <img src={noProperty} alt="No results matching your search" />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                    </>
                                )}
                                {loaders?.pPlan ? (
                                    <SpinnerLoader />
                                ) : (
                                    <>
                                        {allProjectPayment.length > 0 && (
                                            <div className="payment-plan-sec" ref={PlanSectionRef}>
                                                <h2 className="project-title">Payment Plan</h2>
                                                <div className="tab-panel">
                                                    <div className="tab-container">
                                                        <div className="payment-plan-tab">
                                                            <div className="tab-buttons">
                                                                {allProjectPayment
                                                                    .filter((item) => item.title !== null)
                                                                    .map((item, i) => (
                                                                        <button
                                                                            className={`tab-btn${planTab === item?.uId ? " active" : ""} text-capitalize`}
                                                                            onClick={() => {
                                                                                setPlanTab(item?.uId);
                                                                                setPlanData(item);
                                                                            }}
                                                                            key={i}
                                                                        >
                                                                            {item?.title}
                                                                        </button>
                                                                    ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="payment-plan-table">
                                                    <table>
                                                        <thead>
                                                            <tr>
                                                                <th>{planData.type}</th>
                                                                <th className="paid-value">% of Property Value to be Paid</th>
                                                                {/* <th></th> */}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {allProjectPayment
                                                                .filter((item) => item.uId === planTab)
                                                                .map((item, i) => (
                                                                    <React.Fragment key={i}>
                                                                        {/* {item.planInstallments.length > 0 &&
                                                                    item.planInstallments.map((planItem, j) => (
                                                                        <tr key={j}>
                                                                            <td>
                                                                                {planItem?.valuePercentage && planItem?.valuePercentage > 0 && (
                                                                                    <p>{paymentPlanType.find((name) => name.type === planItem.paymentType)?.name}</p>
                                                                                )}
                                                                            </td>
                                                                            <td>
                                                                                <span>{planItem.valuePercentage}%</span>
                                                                            </td>
                                                                            <td>
                                                                                <span>{planItem.paymentDate}</span>
                                                                            </td>
                                                                        </tr>
                                                                    ))} */}
                                                                        {/* {(item?.isInstallmentPreHandover || item?.preHandoverPercentage) && (
                                                                    <tr>
                                                                        <td className="table-tooltip">
                                                                            Pre Handover
                                                                            {item?.isInstallmentPreHandover && (
                                                                                <span>
                                                                                    <div className="wrapper">
                                                                                        <GoDotFill /> Payment Schedule <IoMdInformationCircleOutline />
                                                                                        <div className="tooltip">
                                                                                            <div className="payment-plan-head">
                                                                                                <h3>Payment details</h3>
                                                                                                {item?.planInstallments.length > 0 &&
                                                                                                    item?.planInstallments
                                                                                                        .filter((value) => value?.paymentType === "prehandoverpayment")
                                                                                                        .map((value, i) => (
                                                                                                            <>
                                                                                                                {value?.description && value?.valuePercentage && (
                                                                                                                    <div className="payment-plan-show" key={i}>
                                                                                                                        <span>{value?.description}</span>
                                                                                                                        <strong>{value?.valuePercentage}%</strong>
                                                                                                                    </div>
                                                                                                                )}
                                                                                                            </>
                                                                                                        ))}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </span>
                                                                            )}
                                                                        </td>
                                                                        <td>
                                                                            <span>{item?.preHandoverPercentage}%</span>
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                                {item.handoverPercentage > 0 && (
                                                                    <tr>
                                                                        <td>
                                                                            <p>On Handover</p>
                                                                        </td>
                                                                        <td>
                                                                            <span>{item.handoverPercentage}%</span>
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                                {(item?.isInstallmentPostHandover || item?.postHandoverPercentage !== null) && (
                                                                    <tr>
                                                                        <td className="table-tooltip">
                                                                            Post Handover
                                                                            {item?.isInstallmentPostHandover && (
                                                                                <span>
                                                                                    <div className="wrapper">
                                                                                        <GoDotFill /> Payment Schedule <IoMdInformationCircleOutline />
                                                                                        <div className="tooltip">
                                                                                            <div className="payment-plan-head">
                                                                                                <h3>Payment details</h3>
                                                                                                {item?.planInstallments.length > 0 &&
                                                                                                    item?.planInstallments
                                                                                                        .filter((item) => item?.paymentType === "posthandoverpayment")
                                                                                                        .map((item, i) => (
                                                                                                            <div className="payment-plan-show" key={i}>
                                                                                                                <span>{item?.description}</span>
                                                                                                                <strong>{item?.valuePercentage}%</strong>
                                                                                                            </div>
                                                                                                        ))}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </span>
                                                                            )}
                                                                        </td>
                                                                        <td>
                                                                            <span>{item?.postHandoverPercentage}%</span>
                                                                        </td>
                                                                    </tr>
                                                                )} */}
                                                                        {item.downPaymentPercentage > 0 && (
                                                                            <tr>
                                                                                <td>
                                                                                    <p>Down Payment</p>
                                                                                </td>
                                                                                <td>
                                                                                    <h2>{item.downPaymentPercentage}%</h2>
                                                                                </td>
                                                                                {/* <td>
                                                                            <span>{item.paymentDate}</span>
                                                                        </td> */}
                                                                            </tr>
                                                                        )}
                                                                        {(item?.isInstallmentPreHandover || item?.preHandoverPercentage) && (
                                                                            <tr>
                                                                                <td className="table-tooltip">
                                                                                    Pre Handover
                                                                                    {item?.isInstallmentPreHandover && (
                                                                                        <span>
                                                                                            <GoDotFill /> Payment Schedule
                                                                                            <div className="wrapper">
                                                                                                <IoMdInformationCircleOutline />
                                                                                                <div className="tooltip">
                                                                                                    <div className="payment-plan-head">
                                                                                                        <h3>Payment details</h3>
                                                                                                        {item?.planInstallments.length > 0 &&
                                                                                                            item?.planInstallments
                                                                                                                .filter((value) => value?.paymentType === "prehandoverpayment")
                                                                                                                .map((value, i) => (
                                                                                                                    <>
                                                                                                                        {value?.description && value?.valuePercentage && (
                                                                                                                            <div className="payment-plan-show" key={i}>
                                                                                                                                <span>{value?.description}</span>
                                                                                                                                <strong>{value?.valuePercentage}%</strong>
                                                                                                                            </div>
                                                                                                                        )}
                                                                                                                    </>
                                                                                                                ))}
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </span>
                                                                                    )}
                                                                                </td>
                                                                                <td>
                                                                                    <h2>{item?.preHandoverPercentage}%</h2>
                                                                                </td>
                                                                            </tr>
                                                                        )}
                                                                        {item.handoverPercentage > 0 && (
                                                                            <tr>
                                                                                <td>
                                                                                    <p>On Handover</p>
                                                                                </td>
                                                                                <td>
                                                                                    <h2>{item.handoverPercentage}%</h2>
                                                                                </td>
                                                                            </tr>
                                                                        )}
                                                                        {(item?.isInstallmentPostHandover || item?.postHandoverPercentage !== null) && (
                                                                            <tr>
                                                                                <td className="table-tooltip">
                                                                                    Post Handover
                                                                                    {item?.isInstallmentPostHandover && (
                                                                                        <span>
                                                                                            <GoDotFill /> Payment Schedule
                                                                                            <div className="wrapper">
                                                                                                <IoMdInformationCircleOutline />
                                                                                                <div className="tooltip">
                                                                                                    <div className="payment-plan-head">
                                                                                                        <h3>Payment details</h3>
                                                                                                        {item?.planInstallments.length > 0 &&
                                                                                                            item?.planInstallments
                                                                                                                .filter((item) => item?.paymentType === "posthandoverpayment")
                                                                                                                .map((item, i) => (
                                                                                                                    <div className="payment-plan-show" key={i}>
                                                                                                                        <span>{item?.description}</span>
                                                                                                                        <strong>{item?.valuePercentage}%</strong>
                                                                                                                    </div>
                                                                                                                ))}
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </span>
                                                                                    )}
                                                                                </td>
                                                                                <td>
                                                                                    <h2>{item?.postHandoverPercentage}%</h2>
                                                                                </td>
                                                                            </tr>
                                                                        )}
                                                                    </React.Fragment>
                                                                ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                )}

                                {loaders?.pUnit ? (
                                    <SpinnerLoader />
                                ) : (
                                    <>
                                        {projectUnits.length > 0 && (
                                            <div className="unit-type-sec" ref={UnitSectionRef}>
                                                <h2 className="project-title">Unit Types</h2>
                                                {projectUnits?.map((unit, i) => (
                                                    <div className="filter-dropdown accordian-section" key={i}>
                                                        <h3 className="unit-title">{unit?.categoryName}</h3>
                                                        {unit?.data?.map((items, j) => (
                                                            <div className="accordion unit-accordion" key={j}>
                                                                <div className="accordion-item">
                                                                    <input type="checkbox" id={`accordion-${j + unit?.categoryId}`} className="accordion-toggle" />
                                                                    <label htmlFor={`accordion-${j + unit?.categoryId}`} className="accordion-header unit-accordion-header">
                                                                        <h4>{items?.unitName}</h4>
                                                                        <IoIosArrowDown className="accordion-icon" />
                                                                    </label>
                                                                    <div className="accordion-content">
                                                                        <table>
                                                                            <thead>
                                                                                <tr>
                                                                                    <th>Price</th>
                                                                                    <th>Area</th>
                                                                                    <th>Floor Plan</th>
                                                                                    <th>Image</th>
                                                                                    <th>Video</th>
                                                                                    <th>Document</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {items?.subdata.map((item, k) => (
                                                                                    <tr key={k}>
                                                                                        <td>{item?.monetaries?.price ? formatShortNumber(item?.monetaries?.price) : "-"}</td>
                                                                                        <td>{`${item?.dimension?.unitArea ? item?.dimension?.unitArea?.toLocaleString() : "-"} ${
                                                                                            item?.unitNameResolved ? item?.unitNameResolved : ""
                                                                                        }`}</td>
                                                                                        <td>
                                                                                            {item?.gallery?.floorPlans?.length > 0 ? (
                                                                                                <div onClick={() => setFlooreModalShow({ show: true, data: item?.gallery?.floorPlans })}>
                                                                                                    <AiOutlineTable className="floor-icon cursor-pointer " />
                                                                                                </div>
                                                                                            ) : (
                                                                                                "-"
                                                                                            )}
                                                                                        </td>
                                                                                        <td>
                                                                                            {item?.gallery?.images?.length > 0 ? (
                                                                                                <div onClick={() => setFlooreModalShow({ show: true, data: item?.gallery?.images })}>
                                                                                                    <IoImageOutline className="floor-icon cursor-pointer " />
                                                                                                </div>
                                                                                            ) : (
                                                                                                "-"
                                                                                            )}
                                                                                        </td>
                                                                                        <td>
                                                                                            {item?.gallery?.videos?.length > 0 ? (
                                                                                                <div onClick={() => setFlooreVideoShow({ show: true, data: item?.gallery?.videos })}>
                                                                                                    <IoPlayCircleOutline className="floor-icon cursor-pointer " />
                                                                                                </div>
                                                                                            ) : (
                                                                                                "-"
                                                                                            )}
                                                                                        </td>
                                                                                        <td>
                                                                                            {item?.gallery?.brochures?.length > 0 ? (
                                                                                                <div>
                                                                                                    <a
                                                                                                        href={item?.gallery?.brochures ? imgBaseUrl + item?.gallery?.brochures[0].path : ""}
                                                                                                        download
                                                                                                        target="_blank"
                                                                                                        rel="noreferrer"
                                                                                                    >
                                                                                                        <AiOutlineFilePdf className="floor-icon cursor-pointer " />
                                                                                                    </a>
                                                                                                </div>
                                                                                            ) : (
                                                                                                "-"
                                                                                            )}
                                                                                        </td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </>
                                )}

                                {projectData?.projects?.faqDescription && (
                                    <div className="faq-section" ref={AboutSectionRef}>
                                        <h2 className="project-title">
                                            FAQs about properties for {projectData?.projects?.completionType} in {projectData?.projects?.title}
                                        </h2>
                                        <div className="faq-item" dangerouslySetInnerHTML={{ __html: projectData?.projects?.faqDescription }}></div>
                                    </div>
                                )}

                                {loaders?.pSimilar ? (
                                    <SpinnerLoader />
                                ) : (
                                    <>
                                        {similarProjectData.length > 0 && (
                                            <div className="our-latest-sec similar-project">
                                                <div className="our-build-space">
                                                    <h2 className="similer-project-title">Similar Project</h2>
                                                </div>
                                                <div className="row slider-section info-block">
                                                    <Swiper
                                                        modules={[Navigation, Pagination]}
                                                        slidesPerView={1}
                                                        spaceBetween={10}
                                                        navigation={{ nextEl: ".custom-next", prevEl: ".custom-prev" }}
                                                        pagination={{ clickable: true, el: ".property-pagination" }}
                                                        loop={false}
                                                        breakpoints={{
                                                            480: { slidesPerView: 1 },
                                                            575: { slidesPerView: 2 },
                                                            768: { slidesPerView: 2 },
                                                            1300: { slidesPerView: 2 },
                                                            1400: { slidesPerView: 3 },
                                                        }}
                                                    >
                                                        {similarProjectData.map((item, i) => (
                                                            <SwiperSlide key={i}>
                                                                <div className="slider-card-prp slider-body slider-body-none">
                                                                    <Link to={`/project-details/${item?.slug}_${item?.uId}`} title={item.title} reloadDocument>
                                                                        <div className="slider-card project-slider-card">
                                                                            <div className="slide-card-img image-swiper-wrapper">
                                                                                {item?.images.length > 0 ? (
                                                                                    <Swiper
                                                                                        modules={[Navigation]}
                                                                                        slidesPerView={1}
                                                                                        spaceBetween={20}
                                                                                        navigation={{ nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" }}
                                                                                        // pagination={{ clickable: true }}
                                                                                        loop={false}
                                                                                    >
                                                                                        {item?.images.length > 0 &&
                                                                                            item?.images
                                                                                                .filter((img) => !img.needHide)
                                                                                                .sort((a, b) => {
                                                                                                    if (a.isCover) return -1;
                                                                                                    if (b.isCover) return 1;
                                                                                                    return a.orderRank - b.orderRank;
                                                                                                })
                                                                                                .map((slide, index) => (
                                                                                                    <SwiperSlide className="crad_wrapper_img" key={index}>
                                                                                                        <img
                                                                                                            src={imgBaseUrl + slide?.path}
                                                                                                            alt={slide?.title}
                                                                                                            onError={({ currentTarget }) => {
                                                                                                                currentTarget.onerror = null;
                                                                                                                currentTarget.src = `${NoPropertyImg}`;
                                                                                                            }}
                                                                                                            loading="lazy"
                                                                                                        />
                                                                                                    </SwiperSlide>
                                                                                                ))}
                                                                                        <div className="swiper-button-prev"></div>
                                                                                        <div className="swiper-button-next"></div>

                                                                                        {item?.category?.length > 0 && (
                                                                                            <div className="key_info_value">
                                                                                                <p className="card_ellipsis">{formatNames(item.category)}</p>
                                                                                            </div>
                                                                                        )}
                                                                                    </Swiper>
                                                                                ) : (
                                                                                    <img src={NoPropertyImg} alt="No results matching your search" />
                                                                                )}
                                                                            </div>
                                                                            <div className="heading_title">
                                                                                <h3 className="card_ellipsis">{item?.title}</h3>
                                                                                {item?.developer?.name && (
                                                                                    <p>
                                                                                        By <b>{item?.developer?.name}</b>
                                                                                    </p>
                                                                                )}
                                                                            </div>
                                                                            {item?.address?.locality && (
                                                                                <div className="geo-location">
                                                                                    <RELocation />
                                                                                    <span className="card_ellipsis">{item?.address?.locality ?? ""}</span>
                                                                                </div>
                                                                            )}

                                                                            <div>
                                                                                <div className="flex items-center info_wrapper">
                                                                                    {item?.monetary?.currency && (item?.monetary?.minimumPrice || item?.monetary?.maximumPrice) && (
                                                                                        <div className="item-summary">
                                                                                            <bdi className="flex items-center text-uppercase card_ellipsis">
                                                                                                {`${item?.monetary?.currency} ${
                                                                                                    item?.monetary?.minimumPrice
                                                                                                        ? formatShortNumber(item?.monetary?.minimumPrice)
                                                                                                        : formatShortNumber(item?.monetary?.maximumPrice)
                                                                                                }`}
                                                                                            </bdi>
                                                                                            <span className="card_ellipsis">Launch price</span>
                                                                                        </div>
                                                                                    )}
                                                                                    {item?.completion?.completionDate && (
                                                                                        <div className="item-summary">
                                                                                            <bdi className="flex items-center card_ellipsis">{getQuarter(item?.completion?.completionDate)}</bdi>
                                                                                            <span className="card_ellipsis">handover</span>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </Link>
                                                                </div>
                                                            </SwiperSlide>
                                                        ))}
                                                    </Swiper>
                                                    <div className="custom-nav-arrows">
                                                        <button className={`custom-prev ${similarProjectData.length === 2 ? "swiper-button-lock" : ""}`} aria-label="Previous Slide">
                                                            ❮
                                                        </button>
                                                        <button className="custom-next" aria-label="Next Slide">
                                                            ❯
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>

                            <div className="off-plan-right">
                                <div className="off-plan-container">
                                    <div className="prj_wp_info">
                                        <div className="prj_wp_body">
                                            <h5>Get in touch now for more information.</h5>
                                            <div className="wp_btn">
                                                <button
                                                    className="button mt-0"
                                                    data-framer-name="WhatsApp"
                                                    // href="https://api.whatsapp.com/send/?app_absent=0&amp;phone=971585677441&amp;text&amp;type=phone_number"
                                                    // target="_blank"
                                                    // rel="noopener"
                                                    // style="will-change: transform;opacity: 1;transform: perspective(1200px);"
                                                    onClick={() => sendWhatsAppMessage(wpNumber, "HI")}
                                                >
                                                       <REWhatsapp className="me-1" /> WhatsApp
                                                    {/* <IoLogoWhatsapp fill="#4dbd43" className="me-1" /> */}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    {/* {projectData?.developer && projectData?.developer.length > 0 && (
                                        <div className="card_wrapper">
                                            <div className="card_wrapper_inner pb-0">
                                                <div className="card_wrapper_img">
                                                    <img src={agentData?.path ? imgBaseUrl + agentData?.path : developerLogo} alt="" />
                                                </div>
                                                <div className="card_wrapper_text">
                                                    <p>Developer</p>
                                                    <a href={`/agent-details/${agentData.slug}_${agentData.uId}`} alt={agentData?.name}>
                                                    <h3 className="mb-0">{projectData?.developer[0]}</h3>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    )} */}
                                    <div className="project-agent-details">
                                        <p className="top-agent-title">Explore top agents</p>
                                        <div className="project-info-container">
                                            {loaders.agent ? (
                                                <SpinnerLoader paddingTop={true} />
                                            ) : (
                                                <>
                                                    {agentData.length > 0 &&
                                                        agentData.map((item, i) => (
                                                            <a href={`/agent-details/${item?.slug}_${item?.uId}`} key={i}>
                                                                <div className="project-agent-info">
                                                                    <div className="project-agent-inner">
                                                                        <div className="project-agent-wrapper">
                                                                            <div className="agent-img">
                                                                                <img src={item?.path ? imgBaseUrl + item?.path : dummyImg} alt={item?.name} />
                                                                            </div>
                                                                            <div className="project-agent-name">
                                                                                <p>{item?.name}</p>
                                                                                <span>{item?.languages}</span>
                                                                            </div>
                                                                        </div>
                                                                        <IoIosArrowForward />
                                                                    </div>
                                                                    {item?.agentStats?.propertySaleCount || item?.agentStats?.propertyRentCount ? (
                                                                        <div className="buy-sale-btn">
                                                                            {item?.agentStats?.propertySaleCount && (
                                                                                <button>
                                                                                    For Sale : <bdi>({item?.agentStats?.propertySaleCount})</bdi>
                                                                                </button>
                                                                            )}
                                                                            {item?.agentStats?.propertyRentCount && (
                                                                                <button>
                                                                                    for Rent: <bdi>({item?.agentStats?.propertyRentCount})</bdi>
                                                                                </button>
                                                                            )}
                                                                        </div>
                                                                    ) : (
                                                                        <></>
                                                                    )}
                                                                </div>
                                                            </a>
                                                        ))}
                                                </>
                                            )}
                                        </div>

                                        <div className="amenities-modal text-center">
                                            <Link to="/agents">
                                                <button>
                                                    View All Agents <GoArrowRight />
                                                </button>
                                            </Link>
                                        </div>
                                    </div>

                                    <div className="property-project">
                                        <div className="project-agent-details">
                                            {mediaProject?.images?.length > 0 ? (
                                                <div className={mediaProject?.images?.length === 3 ? "project-details-right" : "project-img-wrapper"}>
                                                    {mediaProject.images.slice(0, 4).map((img, i) => (
                                                        <img
                                                            src={imgBaseUrl + img?.path}
                                                            alt={img?.title}
                                                            key={i}
                                                            title={img?.title}
                                                            onError={({ currentTarget }) => {
                                                                currentTarget.onerror = null;
                                                                currentTarget.src = `${NoPropertyImg}`;
                                                            }}
                                                            loading="lazy"
                                                        />
                                                    ))}
                                                </div>
                                            ) : (
                                                <img src={NoPropertyImg} className="w-100 img-fluid" alt="No results matching your search" />
                                            )}
                                            <div className="project-location">
                                                {DeveloperData?.name && (
                                                    <h2 className="project-title" title={DeveloperData?.name}>
                                                        {DeveloperData?.name}
                                                    </h2>
                                                )}
                                                {DeveloperData?.locality && (
                                                    <p className="card_ellipsis" title={DeveloperData?.locality}>
                                                        <MdLocationOn /> {DeveloperData?.locality}
                                                    </p>
                                                )}
                                                <div className="developers-project">
                                                    {projectData?.developer && projectData?.developer.length > 0 && (
                                                        <div className="developers-location">
                                                            <p>Developer</p>
                                                            <span>{projectData?.developer[0]}</span>
                                                        </div>
                                                    )}
                                                    {projectData?.projects?.completionType === "offplan" && (
                                                        <div className="developers-location">
                                                            <p>Project Status</p>
                                                            <span className="under-project">Under Construction</span>
                                                        </div>
                                                    )}
                                                    {projectData?.completion?.completionDate && (
                                                        <div className="developers-location">
                                                            <p>Handover</p>
                                                            <span>{getQuarter(projectData?.completion?.completionDate)}</span>
                                                        </div>
                                                    )}
                                                    {projectData?.monetaries?.currency && (projectData?.monetaries?.minimumPrice || projectData?.monetaries?.maximumPrice) && (
                                                        <div className="developers-location">
                                                            <p>Starting from</p>
                                                            <span>
                                                                {`${projectData?.monetaries?.currency} ${
                                                                    projectData?.monetaries?.minimumPrice
                                                                        ? formatShortNumber(projectData?.monetaries?.minimumPrice)
                                                                        : formatShortNumber(projectData?.monetaries?.maximumPrice)
                                                                }`}
                                                            </span>
                                                        </div>
                                                    )}
                                                </div>
                                                {/* <div className="links_section">
                                                    <div className="link_body">
                                                        <h3 className="links__title">Recommended searches</h3>
                                                        <ul className="link_wrapper">
                                                            <li></li>
                                                        </ul>
                                                    </div>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                    {recommendedSearch.length > 0 && (
                                        <div className="link-section">
                                            <div className="ltp-link-title">
                                                <h4 className="project-title mb-2">Recommended searches</h4>
                                            </div>
                                            <ul className="links_flex">
                                                {recommendedSearch.map((item, i) => (
                                                    <li key={i}>
                                                        <a href={propertySliug} className="links_item" title={item?.label} onClick={() => handleSearchChange(item)}>
                                                            {item?.label}
                                                        </a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {flooreModalShow.show && <ImagesModal show={flooreModalShow.show} handleHide={handleClose} propertyImgsmdl={flooreModalShow.data} />}
            {flooreVideoShow.show && <VideoModal show={flooreVideoShow.show} handleHide={handleVideoClose} propertyVdosmdl={flooreVideoShow.data} />}
            {emailModalShow && <EmailAgentModal show={emailModalShow} onHide={handleModalHide} />}
            {phoneModalShow.show && <ContectModal show={phoneModalShow.show} onHide={handlePhoneModalHide} />}
        </>
    );
}

export default ProjectDetails;
